'use strict';

var $ = require('jquery');
var Carousel = require('./Carousel.js');

function init() {
	var carousel = new Carousel({
		item: 'slide',
		carouselSpeed: 6000,
		doPreviousClass: true,
		imageInterval: 6000,
		doAutoAdvance: document.getElementsByClassName('carousel__link').length > 1
	});

	carousel.activate();
}

module.exports = {
	init : init
};